import { render, staticRenderFns } from "./ApprovalTable.vue?vue&type=template&id=e4737a42&"
import script from "./ApprovalTable.vue?vue&type=script&lang=js&"
export * from "./ApprovalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports